import classNames from 'classnames';
import Icon from '../icon/Icon';
import React from 'react';

const styles = require('./Alert.module.scss');

export type AlertVariant = 'info' | 'success' | 'warning' | 'error';

const ICON_NAME: Record<AlertVariant, string> = {
  info: 'info',
  success: 'circleCheck',
  warning: 'circleAlert',
  error: 'triangleAlert',
};

const ALERT_ROLE: Record<AlertVariant, 'alert' | 'status'> = {
  info: 'status',
  success: 'status',
  warning: 'alert',
  error: 'alert',
};

export interface AlertProps {
  className?: string;
  description?: React.ReactNode;
  message: React.ReactNode;
  variant?: AlertVariant;
}

const Alert: React.FC<AlertProps> = ({
  className,
  description,
  message,
  variant = 'info',
}) => (
  <div
    className={classNames(styles.alert, styles[variant], className)}
    role={ALERT_ROLE[variant]}
  >
    <Icon
      name={ICON_NAME[variant]}
      size="md"
      color={`${variant}-border-base`}
      aria-hidden="true"
    />
    <div className={styles.content}>
      {typeof message === 'string'
        ? <div className={styles.message} dangerouslySetInnerHTML={{ __html: message }} />
        : <div className={styles.message}>{message}</div>
      }
      {description && (
        <div className={styles.description}>{description}</div>
      )}
    </div>
  </div>
);

export default Alert;
